<script>

import cTable from "@/base/common/index.vue";
import detail from "@/view/order/miscellaneousQuotation/detail.vue";
import {getSelectType} from "@/api/public";
import {getOtherFee, getOtherFeeResult} from "@/api/finance/other_fee_hq";
import {getAllClient, getCompanies} from "@/api/user/client";
import {getExpense} from "@/api/finance/expense";
import {getUser} from "@/api/user/internal";

export default {
  name: 'other_fee_hq_quotation',
  components: {detail, cTable},
  async mounted() {
    let client = (await getAllClient()).data.payload.rows;
    let expense_item = (await getExpense()).data.payload.rows;
    let salesman = (await getUser({ standard: "Salesman" })).data.payload.rows;

    this.header.searchs.forEach(item => {
      if (item.key === "client_id") item.options = client;
      if (item.key === "expense_item_id") item.options = expense_item;
      if (item.key === "salesman_id") item.options = salesman;
    });
  },
  data() {
    return {
      config: {
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          key: "checkbox",
          fixed: "left"
        },
        {
          name: () => this.$t("Odd_Numbers"),
          key: "airway_number",
          minWidth: 110
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          minWidth: 110
        },
        {
          name: () => this.$t("salesman"),
          key: "salesman_account",
          minWidth: 110
        },
        {
          name: () => this.$t("batch_number"),
          key: "batch_number",
          minWidth: 110
        },
        {
          name: () => this.$t("invoiceWeight"),
          key: "actual_weight",
          minWidth: 110
        },
        {
          name: () => this.$t("square"),
          key: "volume",
          minWidth: 110
        },
        {
          name: () => this.$t("CTNS"),
          key: "pcs",
          minWidth: 110
        },
        {
          name: () => this.$t("Expense Item"),
          key: "expense_name",
          minWidth: 110
        },
        {
          name: () => this.$t("expType"),
          key: "expense_type",
          minWidth: 110
        },
        {
          name: () => this.$t("billing_unit"),
          key: 'charge_unit',
          minWidth: 110
        },
        {
          name: () => this.$t("billing_price"),
          key: "charge_price",
          minWidth: 110
        },
        {
          name: () => this.$t("amount_receivable"),
          key: "charge_fees",
          minWidth: 110
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 220
        },
      ],
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "is_finance",
            component: "Select",
            placeholder: () => this.$t("whetherFreight"),
            clearable: true,
            options: [
              { label: this.$t("YES"), value: "YES" },
              { label: this.$t("NO"), value: "NO" }
            ]
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" }
          },
          {
            name: () => this.$t("Expense Item"),
            key: "expense_item_id",
            component: "Select",
            placeholder: () => this.$t("Expense Item"),
            config: {
              label: "name",
              value: "id"
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 2
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export") + '应收',
              type: "export",
              fnName: "export2",
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
          ],
          methods: {
            async export2({ searchForm }) {
              this.handleRequestMethods(
                "list",
                {
                  ...searchForm,
                  export: 9,
                  ids: this.selectAll.map(t => t.id)
                },
                false,
                true
              ).then(res => {
                window.open(this.$globalUrl + res.payload);
              });
            },
          }
        }
      },
      methods: {
        list: params => getOtherFeeResult(Object.assign(params, { v: 2 })),
      },
      modals: {},
      footer: {},
    }
  }
}
</script>

<template>
  <cTable
    :config="config"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<style scoped>

</style>
